/**
 * Created by mark on 19/02/2018.
 */


/**
 * Created by mark on 29/01/2018.
 */

import React  from 'react';
import {Button , Breadcrumb , FormGroup , ControlLabel , Tabs , Tab , Row , Col , NavItem , Nav} from 'react-bootstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import Translation from '../../../store/internationalization-store.js';
import Downloader from '../../../classes/download.js';

let ranges = [
    {thresholdLower:70 , thresholdHigher:100 , total:0 , color:"#88c057"},
    {thresholdLower:40 , thresholdHigher:70  , total:0 , color:"#ffcc66"},
    {thresholdLower:1 , thresholdHigher:40   ,  total:0 , color:"#ed7161"},
    {thresholdLower:0 , thresholdHigher:0   ,  total:0 , color:"#ffffff"}
];
export default class DetailTable extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            headers:[],
            data:[],
        }
    }

    componentWillReceiveProps(props) {
        this.props = props

        if(this.props.triggerDownload)
        {
            this.handelDownloadRequest();
        }
    }

    handelDownloadRequest(){
        var csv = [];
        var row = ["" ,  Translation.getModuleNoIndexTranslation(this.props.name , this.props.name)];
        csv.push(row.join(","));

        var row = [""];
        for(var idx = 0 ; idx < this.props.headers.length; idx++)
        {
            row.push(Translation.get(this.props.headers[idx].title , this.props.headers[idx].title));
        }

        csv.push(row.join(","));

        for(var idx = 0 ; idx < this.props.data.length; idx++)
        {
            var _row = this.props.data[idx];
            var row = [];
            row.push(_row.name);

            var index = 0;
            for(var jdx = 0; jdx < this.props.headers.length; jdx++)
            {
                var key = this.props.headers[jdx].gameUid;
                row.push(_row[key]);
            }

            csv.push(row.join(","));
        }


        (new Downloader()).download_csv(csv.join("\n"));
    }

    getBackgroundColor(value){
        var test = function(value , thresholdLower , thresholdHigher){

            value = String(value).replace('%' , '');

            console.log(value)
            if(value == 0 && thresholdLower == 0)
            {
                return true;
            }

            return value > Number(thresholdLower) && value <= Number(thresholdHigher)
        };


        let col;


        for(var r = 0 ; r < ranges.length; r++)
        {
            if(test(value , ranges[r].thresholdLower , ranges[r].thresholdHigher))
            {
                col = ranges[r].color
                break;
            }
        }


        return col;
    }

    formatterColor(cell){

        console.log(arguments)
        return {
            background:this.getBackgroundColor(cell)
        }
    }

    componentWillReceiveProps(props){

        this.props = props;

        if(this.props.triggerDownload == true)
        {
            this.handelDownloadRequest();
          //  this.props.onDownload();
        }


    }

    getTableData(){
        return this.props.data || [];
    }


    render(){

        const tableOptions = {
            page: 1,  // which page you want to show as default
            sizePerPage: 30,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationShowsTotal: false,
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            hideSizePerPage: true,
            alwaysShowAllBtns: true, // Always show next and previous button
            withFirstAndLast:true,
            firstPage: '...', // First page button text
            lastPage: '...', // Last page button text
        };


        var headers = [];

        var width = 80/this.props.headers.length;
        for(var idx = 0;  idx < this.props.headers.length; idx++)
        {
            headers.push(
                <TableHeaderColumn tdStyle={ this.formatterColor.bind(this) } width={width+'%'} row='1' rowSpan='1' dataField={this.props.headers[idx].gameUid} >
                    <small>
                        {Translation.get(this.props.headers[idx].title , this.props.headers[idx].title)}
                    </small>
                </TableHeaderColumn>
            );
        }


        return   <div>
            <BootstrapTable options={tableOptions} data={ this.getTableData() } keyField='id'   pagination  bordered={ true }>
                <TableHeaderColumn row='0' rowSpan='2'  width={'20%'} dataField='name' ></TableHeaderColumn>
                <TableHeaderColumn row='0' colSpan={this.props.headers.length } dataField='title' >
                    <a onClick={this.props.onClick}style={{width:"100%"}}><i className="zmdi zmdi-arrow-left"></i>
                        &nbsp;&nbsp;
                        {Translation.getModuleNoIndexTranslation(this.props.name , this.props.name)}
                    </a>
                </TableHeaderColumn>
                {headers}
            </BootstrapTable>
        </div>
    }

}